import React from 'react'
import parse from 'html-react-parser';

import DisplayTable from './CalloutTable'
import DisplayList from './CalloutList'

export default function ({topCallout, data}) {
  return (
    <div className='calloutBox'>
      <div className="calloutBox__content">
      <div className='topCallout'>

          {parse(topCallout)}

      </div>
      {
        data.hasOwnProperty('length')
         ? (<DisplayList data={data} />)
         : (<DisplayTable data={data} />)
      }
      </div>
    </div>
  )
}
